module.exports = __webpack_public_path__ + "img/Loyalty-Image.d45a07ea.png";